package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.model.player.CreatePlayerRequest
import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository

class CreatePlayerUseCase(
    private val repository: PlayerRepository
) {
    suspend operator fun invoke(request: CreatePlayerRequest): Result<Unit> {
        return repository.createPlayer(request)
    }
}
